import React, { useMemo } from "react";
import { FETCH_PROJECT_QUERY } from "src/constants/graphql/queries";
import { useQuery } from "@apollo/client/react";
import { getOutboundBillingType } from "src/utils/billingHelpers";
import {
  BY_THE_PALLET,
  BY_THE_PALLET_WAREHOUSE_BUILT,
  BY_THE_UNIT_ITEM,
  BY_THE_VAULT,
  TIME_AND_MATERIALS_BLENDED,
  TIME_AND_MATERIALS_ITEMIZED,
} from "src/components/project/settings/utils/billingTypes";
import OutboundBillingModals from "./OutboundBillingModals";
import useHasAdditionalCharges from "src/components/capture/ReceivingWizard/hooks/useHasAdditionalCharges";

export default function OutboundBillingModal({ open, inventoryRequest, onClose }) {
  const { data: { project = {} } = {}, loading } = useQuery(FETCH_PROJECT_QUERY, {
    variables: { id: inventoryRequest?.projectId },
    skip: !inventoryRequest?.projectId,
    fetchPolicy: "cache-first",
  });

  const billingType = useMemo(() => getOutboundBillingType(project), [project]);

  const isAllowedOutboundBillingType = useMemo(() => {
    return [
      BY_THE_PALLET,
      BY_THE_PALLET_WAREHOUSE_BUILT,
      BY_THE_UNIT_ITEM,
      BY_THE_VAULT,
      TIME_AND_MATERIALS_BLENDED,
      TIME_AND_MATERIALS_ITEMIZED,
    ].includes(billingType);
  }, [billingType]);

  if (!open || loading) {
    return null;
  }

  const hasAdditionalCharges = useHasAdditionalCharges(project, "outbound");
  const initialStep = isAllowedOutboundBillingType
    ? "quantities"
    : hasAdditionalCharges
    ? "charges"
    : "confirmation";

  return (
    <OutboundBillingModals
      initialStep={initialStep}
      inventoryRequest={inventoryRequest}
      billingType={billingType}
      hasAdditionalCharges={hasAdditionalCharges}
      onClose={onClose}
      palletTypes={project?.palletTypes}
      unitTypes={project?.unitTypes}
    />
  );
}
